/**
 * @flow
 * @relayHash c6124aefdd7dc34524eea4c6abc75635
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddItemCategoryInput = {|
  name: string,
  description?: ?string,
|};
export type AddItemCategoryMutationVariables = {|
  input: AddItemCategoryInput
|};
export type AddItemCategoryMutationResponse = {|
  +addItemCategory: {|
    +itemCategoryEdge: {|
      +node: {|
        +id: string,
        +name: string,
        +description: ?string,
      |}
    |}
  |}
|};
export type AddItemCategoryMutation = {|
  variables: AddItemCategoryMutationVariables,
  response: AddItemCategoryMutationResponse,
|};
*/


/*
mutation AddItemCategoryMutation(
  $input: AddItemCategoryInput!
) {
  addItemCategory(input: $input) {
    itemCategoryEdge {
      node {
        id
        name
        description
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddItemCategoryInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addItemCategory",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddItemCategoryPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "itemCategoryEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemCategoryEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemCategory",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddItemCategoryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddItemCategoryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddItemCategoryMutation",
    "id": null,
    "text": "mutation AddItemCategoryMutation(\n  $input: AddItemCategoryInput!\n) {\n  addItemCategory(input: $input) {\n    itemCategoryEdge {\n      node {\n        id\n        name\n        description\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '33c6d305f26ce74c7b0b2d6ea58c2a8a';
module.exports = node;
